import React from 'react';
import { Form } from 'react-bootstrap';

const SearchBar = ({ searchQuery, setSearchQuery }) => {
  return (
    <Form className="m-5" onSubmit={(e)=> {
        e.preventDefault();
    }}>
      <Form.Control
        type="text"
        placeholder="Search by any field..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ textAlign: 'center' }}
      />
    </Form>
  );
};

export default SearchBar;
